import { createSelector } from 'reselect';

import OrganizationBetaFeaturesApi from './Api';

export const ORGANIZATION_BETA_FEATURES_NAMESPACE = 'organizationBetaFeatures';

export const getOrganizationBetaFeatureStatus = (organizationBetaFeatureName) =>
  createSelector(
    (state) => state[ORGANIZATION_BETA_FEATURES_NAMESPACE],
    (organizationBetafeatures) => organizationBetafeatures?.[organizationBetaFeatureName]?.active || false
  );

export const fetchOrganizationBetaFeatureStatus = (organizationBetaFeatureName) => ({
  fetchingApiFunc: OrganizationBetaFeaturesApi.status,
  selector: getOrganizationBetaFeatureStatus(organizationBetaFeatureName),
  paramsFromProps: () => [organizationBetaFeatureName],
  propertyName: organizationBetaFeatureName,
  dataNamespace: ORGANIZATION_BETA_FEATURES_NAMESPACE,
  alwaysFetch: false,
});
